import React, { useState, useEffect, useMemo, Dispatch, SetStateAction } from "react";
import { Account, Attachment, useFetchStarred, TreeItem, DriveEntryType, DriveConstants, TreeItemType } from "src/common";
import { Loading, TreeFolderIcon } from "src/components";



type AllProps = {
    current_account: Account;
    current_attachment?: Attachment;
    setDestination: Dispatch<SetStateAction<TreeItem | undefined>>;
}

function StarredTabComponent(props: AllProps) {
    const { current_account, setDestination } = props;
    const [active, setActive] = useState<string | undefined>();
    const [is_starred_loading, setIsStarredLoading] = useState<boolean>(false);
    const [is_starred_loaded, setIsStarredLoaded] = useState<boolean>(false);
    const { starred_list, error: starred_error, fetchStarredList, resetStarredList } = useFetchStarred(current_account);

    // Description: Parse the returned folder entries (GenericEntryEntity) into TreeItem[] for building the flat tree
    const starred_folder_items = useMemo<TreeItem[]>(() => {
        if (!starred_list) {
            return [];
        }

        const folder_entries = starred_list.entries.filter((entry) => {
            const is_folder = entry.type !== DriveEntryType.FILE;
            return is_folder && !entry.is_deleted;
        });

        return folder_entries.map((entry) => {
            return {
                collection_id: entry.collection_id,
                id: entry.id,
                name: entry.name,
                path: `${DriveConstants.ROOT_DIRECTORY}/${entry.name}`,
                starred: true,
                type: entry.type === DriveEntryType.LINK ? TreeItemType.link : TreeItemType.folder,
            };
        });
    }, [starred_list]);

    // Description: Fetch starred folders list when Starred tab is selected.
    useEffect(() => {
        setIsStarredLoading(true);
        fetchStarredList();
        return () => {
            resetStarredList();
        };
    }, []);

    useEffect(() => {
        if (is_starred_loading && (!!starred_list || !!starred_error)) {
            setIsStarredLoaded(true);
            setIsStarredLoading(false);
        }
    }, [is_starred_loading, starred_error, starred_list]);

    return <div className="move-folders">
        {
            (!is_starred_loaded || is_starred_loading) && <Loading className="in-place" />
        }
        {
            (is_starred_loaded && !is_starred_loading && !!starred_error) &&
            <p className="p-4 text-muted">Unable to load Starred folders</p>
        }
        {
            (is_starred_loaded && !is_starred_loading && !starred_error && starred_folder_items.length === 0) &&
            <p className="p-4 text-muted">No Starred folders</p>
        }
        {
            is_starred_loaded && !is_starred_loading && !starred_error && starred_folder_items.length > 0 &&
            <div className="tree move-tree">
                {
                    starred_folder_items.map((item) => {
                        return <div
                            className="folder-item"
                            key={`${item.collection_id || ""}-${item.id || ""}`}
                            onClick={() => {
                                !!item.id ? setActive(item.id) : setActive(undefined);
                                setDestination(item);
                            }} >
                            <div className={`folder-label${active === item.id ? " active" : ""}`}>
                                <span className="folder-icon no-children">
                                    <TreeFolderIcon folder={item} open={false} is_flat={true} />
                                </span>
                                <span className="folder-name">{item.name}</span>
                            </div>
                        </div>;
                    })
                }
            </div>
        }
    </div>;
}
export default React.memo(StarredTabComponent);